import React, { lazy, Suspense } from 'react';
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute.js";
import LoadingComponent from '../LoadingComponent/LoadingComponent.js';

const StationsPage = lazy(() => import("../../StationsPage/StationsPage.js"));
const DevStationsPage = lazy(() => import("../../StationsPage/DevStationsPage.js"));
const ChannelPage = lazy(() => import("../../ChannelPage/ChannelPage.js"));
const AdminPage = lazy(() => import("../../AdminPage/AdminPage.js"));
const AlertsPage = lazy(() => import("../../AlertsPage/AlertsPage.js"));
const GA4AnalyticsPage = lazy(() => import("../../GA4AnalyticsPage/GA4AnalyticsPage.js"));
const MapPage = lazy(() => import("../../MapPage/MapPage.js"));
const ProfilePage = lazy(() => import("../../ProfilePage/ProfilePage.js"));
const SettingsPage = lazy(() => import("../../SettingsPage/SettingsPage.js"));
const DebugPage = lazy(() => import("../../DebugPage/DebugPage.js"));
const BroadcastPage = lazy(() => import("../../BroadcastPage/BroadcastPage.js"));
const DashboardPage = lazy(() => import("../../DashboardPage/DashboardPage.js"));

export default function RoutingComponent() {
    return (
        <Suspense fallback={<LoadingComponent />}>
            <Routes>
                <Route element={<ProtectedRoute />}>
                    <Route path="/stationspage" element={<StationsPage />} />
                    <Route path="/devpage" element={<DevStationsPage />} />
                    <Route path="/channelpage/:channelID" element={<ChannelPage />} />
                    <Route path="/adminpage" element={<AdminPage />} />
                    <Route path="/alertspage" element={<AlertsPage />} />
                    <Route path="/analyticspage" element={<GA4AnalyticsPage />} />
                    <Route path="/mappage" element={<MapPage />} />
                    <Route path="/profilepage" element={<ProfilePage />} />
                    <Route path="/settingspage" element={<SettingsPage />} />
                    <Route path="/debugpage" element={<DebugPage />} />
                    <Route path="/broadcastpage" element={<BroadcastPage />} />
                    <Route path="/" element={<DashboardPage />} />
                </Route>
            </Routes>
        </Suspense>
    );
}
